<template>
  <input :type="inputType" @keyup="updateValue" />
</template>

<script>
  import Cleave from 'cleave.js'
  export default {
    props: ['value', 'options', 'type'],
    computed: {
      inputType() {
        return this.type || 'text'
      },
    },
    mounted() {
      this.cleave = new Cleave(this.$el, this.options)
      this.cleave.setRawValue(this.value)
    },
    destroyed() {
      this.cleave.destroy()
    },
    methods: {
      updateValue() {
        const val = this.cleave.getRawValue()
        if (val !== this.value) {
          this.$emit('input', val)
        }
      },
      updateInput() {
        this.cleave.setRawValue(this.value)
      },
    },
  }
</script>
